import { gql } from "@apollo/client";

export const JOB_CATEGORIES_QUERY = gql`
  query JobCategoriesQuery {
    jobCategories {
      label
      value
      subCategories {
        label
        value
        type
        __typename
      }
      __typename
    }
  }
`;

export const USER_JOB_PREFERENCES_QUERY = gql`
  query UserJobPreferencesQuery {
    me {
      id
      canSeePgaProJob
      jobPreference {
        id
        jobSearchStatus
        jobCategories
        minimumCompensation
        jobLocations
        openToSeasonal
        openToInternational
        optedInToJobSeekerEmails
        __typename
      }
      __typename
    }
  }
`;
